// import { post, get, getBlob } from '../../../../services/request';
import { post, get } from '../../../../services/request';

//-------------------Exam Data Dropdown Options - start----------------//
// Get exam data dropdown options
export const getExamDropdownOptions = (payload) => {
    return post(`ExamData/GetExamDataAllDDList`, payload);
};
//-------------------Exam Data Dropdown Options - end----------------//

// Get Recalculate Data
export const getRecalculateData = () => {
    return get(`ExamData/GetReCalculateRecordData`);
};

// Exam data record date
export const updateExamDataRecordDate = (payload) => {
    return post(`ExamData/GetExamDataRecordDate`, payload)
};

// Get all exam data
export const getAllExamData = (payload) => {
    return post(`ExamData/GetAllExamDataWithPagination`, payload);
};

// Export calculated exam data as a binary workbook (not Base64-in-JSON) so very large
// date ranges avoid the size/memory overhead of the generic exportToCSVRequest flow.
// export const exportCalculatedExamDataToCSV = (fromDate, toDate) => {
//     return getBlob(`ExamData/ExportCalculatedExamDataToCSV`, { FromDate: fromDate, ToDate: toDate });
// };

// Calculated exam data (exam, excluded and unassigned lists) for one slice of the export range.
// The export fetches about a day per request so each call stays well under Azure App Service's
// 230-second request limit (see examDataSaga.js).
export const getCalculatedExamDataByRange = (fromDate, toDate) => {
    return get(`ExamData/GetAllCalculatedExamData`, { FromDate: fromDate, ToDate: toDate });
};

//refresh raw exam data
export const refreshRawExamData = (payload) => {
    // Accepts a single object: { fromDate, toDate, userId }
    const { fromDate, toDate, userId } = payload || {};

    if (!fromDate || !toDate) throw new Error('fromDate and toDate are required for refreshRawExamData');
    return post(`ExamData/ReCalculateExamDataDetailsByDate?FromDate=${fromDate}&ToDate=${toDate}&CreatedBy=${userId}`);
};

// Get exam data from batch
export const getBatchRecordExamData = (ID) => {
    return get(`ExamData/GetExamDataDetailsByExamID?ExamDataID=${ID}`);
};

//Get batch by record date
export const getExamDataBatchByRecordDate = (recordDate) => {
    return get(`ExamData/GetExamDataBatchByRecordDate?recordDate=${recordDate}`);
}

// Save Batch Record

export const saveBatchRecord = (payload) => {
    return post(`ExamData/UpdateIsExcluded`, payload);
}

// Check Recalculation
export const checkRecalculation = () => {
    return get(`ExamData/CheckRecalculations`);
};

// Re Calculate Exam Data Details
export const reCalculateExamDataDetails = (payload) => {
    return post(`ExamData/ReCalculateExamDataDetails`, payload);
};

// Get unique unassigned exam data combinations (facility/priority/subspeciality + date last seen)
export const getUnassignedCombinations = (payload) => {
    return post(`ExamData/GetUnassignedCombinations`, payload);
};

// Check worklist assignments for currently unassigned exam data
export const checkWorklistAssignments = (payload) => {
    return post(`ExamData/CheckworklistAssignments`, payload);
};

// Save worklist remapping for selected exam data ids
export const saveWorklistMapping = (payload) => {
    return post(`ExamData/SaveWorklistMapping`, payload);
};

export const saveWorklistMappingUpdate = (payload) => {
    return post(`ExamData/SaveWorklistMappingUpdate`, payload);
};

//-------------------Exam Data - end----------------//